import hkOperation from './hk-operation.vue'

export default hkOperation
